import React from "react";
import { getHeadingElement, HeadingType } from "../types/headingType";
import styles from "./DescriptionText.module.scss";

interface Props {
  children: React.ReactNode;
  headingType?: HeadingType;
}

export const DescriptionTextLeadIn: React.FC<
  React.PropsWithChildren<Props>
> = ({ children, headingType }) => {
  const Tag = getHeadingElement(headingType) || "div";
  return (
    <div className={styles.leadIn}>
      <Tag>{children}</Tag>
    </div>
  );
};

export const DescriptionTextContent: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <div className={styles.content}>{props.children}</div>;
};

export const DescriptionText: React.FC<React.PropsWithChildren<unknown>> = (
  props
) => {
  return (
    <div
      className={styles.descriptionText}
      data-content-name="description_text"
    >
      {props.children}
    </div>
  );
};
